import * as Schema from '../schema';
import assembleEntity from '../schema/assembleEntity';
import { createSelector } from 'reselect';

export const selectComposers = createSelector(
  [state => state.entities, state => state.maps.composers, (state, id) => id],
  (entities, composers, id) => {
    if (composers[id]) {
      return assembleEntity(Schema.PersonList, entities, composers[id].entities);
    }
    return [];
  }
);

export const selectComposersIsLoading = (state, id) =>
  state.maps.composers[id] && state.maps.composers[id].loading;

export const selectNextComposersCursor = (state, id) => {
  const cursor = state.maps.composers[id] && state.maps.composers[id].meta.cursor;
  if (cursor) {
    return cursor.next;
  }
  return null;
};

export const selectPrevComposersCursor = (state, id) => {
  const cursor = state.maps.composers[id] && state.maps.composers[id].meta.cursor;
  if (cursor) {
    return cursor.prev;
  }
  return null;
};
